function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00ce7c;}"));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "182.63 28 168.67 0 154.87 0 154.87 28 172.24 28 186.2 55.99 200 55.99 200 28 182.63 28"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "112.76 23.26 112.76 23.26 112.76 28.13 112.76 28.13 117.87 28.13 117.87 43.75 123.5 43.75 123.5 28.13 128.61 28.13 128.61 28.13 128.84 28.13 128.84 23.26 112.76 23.26"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "135.62 38.87 135.62 35.9 142.11 35.9 142.11 31.22 135.62 31.22 135.62 28.13 143.93 28.13 143.93 28.13 143.93 23.26 143.93 23.26 130.31 23.26 130.31 28.13 130.31 43.75 144.54 43.75 144.54 38.87 135.62 38.87"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "12.52 34.83 12.47 34.86 5.22 23.26 0 23.26 0 43.75 5.37 43.75 5.37 32.52 5.42 32.52 12.52 43.75 17.92 43.75 17.92 23.26 12.52 23.26 12.52 34.83"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "25.98 35.9 32.47 35.9 32.47 31.22 25.98 31.22 25.98 28.13 34.29 28.13 34.29 23.26 20.66 23.26 20.66 43.75 34.89 43.75 34.89 38.87 25.98 38.87 25.98 35.9"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M367.5,292.58c-6.29,0-10.65,4.33-10.65,10.56s4.36,10.54,10.65,10.54,10.65-4.28,10.65-10.54S373.73,292.58,367.5,292.58Zm0,16c-2.86,0-4.88-2.4-4.88-5.43s2-5.42,4.88-5.42,4.87,2.42,4.87,5.42S370.38,308.57,367.5,308.57Z",
  transform: "translate(-320.94 -269.64)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M390.3,297.86a6,6,0,0,1,4.33,2.14l4-3.44a10.87,10.87,0,0,0-8.34-4c-6.84,0-10.71,4.7-10.71,10.59,0,6.84,4.65,10.51,10.71,10.51a10.76,10.76,0,0,0,8.34-3.9l-4-3.46a5.57,5.57,0,0,1-4.33,2.07,5.28,5.28,0,0,1,0-10.53Z",
  transform: "translate(-320.94 -269.64)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M416,300.17c0-4.21-2.31-7.27-7.47-7.27h-8.2v20.49h5.31v-6.26h1.27l3.87,6.26h6.38l-4.68-7.1A6.3,6.3,0,0,0,416,300.17Zm-8.39,2.22h-2v-4.67h2c2,0,2.71,1.07,2.71,2.33C410.33,301.58,409.35,302.39,407.62,302.39Z",
  transform: "translate(-320.94 -269.64)"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  points: "102.98 35.9 109.47 35.9 109.47 31.22 102.98 31.22 102.98 28.13 111.29 28.13 111.29 23.26 97.67 23.26 97.67 43.75 111.89 43.75 111.89 38.87 102.98 38.87 102.98 35.9"
});

function SvgNeocreteLogoRgbPriority1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 200 55.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeocreteLogoRgbPriority1);
export default __webpack_public_path__ + "static/media/NEOCRETE_LOGO_RGB_PRIORITY_1.ae653bc9.svg";
export { ForwardRef as ReactComponent };